import { ActionTree } from 'vuex';
import { AxiosInstance, AxiosResponse } from 'axios';
import { CateringBotState, RootState } from '../types';
import { state as authState } from '../auth/auth';
import { handleAllErrors } from '@/utils/errorHandling';

const BASE = '/rally-intelligence/catering-bot/guest';

export const actions: ActionTree<CateringBotState, RootState> = {

	/**
	 * Run the active (or specified) prompt against the given parameters.
	 * Hits the same endpoint linguini's storefront uses, so admin testing and
	 * customer ordering share one backend route.
	 *
	 * @param {{ payload: CateringRecommendationRequest, locale?: string }} args
	 * @return {Promise<CateringPackagesResponse | void>}
	 */
	async tryPrompt({}, { payload, locale }: { payload: CateringRecommendationRequest; locale?: string }): Promise<CateringPackagesResponse | void> {
		const axiosInst: AxiosInstance = authState.axiosInst;
		try {
			// Locale must be sent as an HTTP header; the backend resolves the
			// active language from `Locale` (then `Accept-Language`) — body fields are stripped.
			const config = locale ? { headers: { Locale: locale } } : undefined;
			const { data }: AxiosResponse<CateringPackagesResponse> = await axiosInst.post(`${BASE}/generate-package`, payload, config);
			return data;
		}
		catch (error) {
			handleAllErrors(error);
		}
	},

	/**
	 * Refine a single existing package using free-text instructions.
	 * Response envelope matches generate-package; refined package is packages[0].
	 *
	 * @param {CateringRefineRequest} payload
	 * @return {Promise<CateringPackagesResponse | undefined>}
	 */
	async refinePackage({}, payload: CateringRefineRequest): Promise<CateringPackagesResponse | undefined> {
		const axiosInst: AxiosInstance = authState.axiosInst;
		try {
			const { data }: AxiosResponse<CateringPackagesResponse> = await axiosInst.post(`${BASE}/refine-package`, payload);
			return data;
		}
		catch (error) {
			handleAllErrors(error);
		}
	}
};
